import { render, staticRenderFns } from "./inspection-report-received.vue?vue&type=template&id=01e74d43"
import script from "./inspection-report-received.vue?vue&type=script&lang=js"
export * from "./inspection-report-received.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports